import  React from 'react'
import * as H from 'history'
import { ApplicationController } from '../../../../controllers/ApplicationController'
import { DashboardDetailModel } from '../../../../models/DashboardDetailModel'
import { DashboardModel } from '../../../../models/DashboardModel'
import { ISupportSpinner } from '../../../../shared/Ajax'
import { Backdrop } from '../../../../shared/Backdrop'
import { TableBody, TableColumn } from '../../../../shared/table'
import { getFY } from '../../../../shared/Utility'

export interface Props {
    searchTxt: string
    history: H.History
}

export interface State {
    loading?: boolean
    historyData: DashboardModel
}

export default class HistoryIndex extends React.Component<Props, State> implements ISupportSpinner {
    ajax : ApplicationController
    constructor(props: Props) {
      super(props)
      this.ajax = new ApplicationController()

      this.state = {
        loading: false,
        historyData: null,
      }
    }

    componentDidMount() {
      this.ajax.getHistoryList(this,
        (d: DashboardModel) => {
          const { historyData } = this.state
          if (JSON.stringify(historyData) !== JSON.stringify(d)) {
            this.setState({ historyData: d })
          }
        })
    }

    handleApplicationClick = (val: string): void => {
      const { history } = this.props
      history.push(`/dashboard-reform/history/${val}`)
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
      this.setState({ loading: on }, callback)
    }

    render() {
      const { searchTxt } = this.props
      const { loading, historyData } = this.state

      if (!historyData) return <div />

      let columns: TableColumn<DashboardDetailModel>[]

      if (historyData.isConsultant) {
        columns = [
            { name: 'Financial Year', content: (r) => getFY(+r.grantYear) },
            { name: 'Applicant', content: (r) => r.organisationName, width: '200px' },
            { name: 'Application ID', content: (r) => r.claimRandomIdentifier, width: '160px', responsive: 'md' },
            { name: 'Primary Contact', content: (r) => r.primaryContactName || <div style={{ fontStyle: 'italic' }}>NA</div>, responsive: 'md' },
            { name: 'Agent Contact', content: (r) => r.agentContactName || <div style={{ fontStyle: 'italic' }}>NA</div>, responsive: 'md' },
            { name: 'Status', content: (r) => r.applicationStatus, responsive: 'md' },
            { name: 'Grant Paid', content: (r) => r.totalAmountPaid },
        ]
      } else {
        columns = [
          { name: 'Financial Year', content: (r) => getFY(+r.grantYear) },
          { name: 'Application ID', content: (r) => r.claimRandomIdentifier, width: '160px', responsive: 'md' },
          { name: 'Primary Contact', content: (r) => r.primaryContactName || <div style={{ fontStyle: 'italic' }}>NA</div> },
          { name: 'Agent Contact', content: (r) => r.agentContactName || <div style={{ fontStyle: 'italic' }}>NA</div>, responsive: 'md' },
          { name: 'Status', content: (r) => r.applicationStatus, responsive: 'md' },
          { name: 'Grant Paid', content: (r) => r.totalAmountPaid },
        ]
      }

      return (
        <>
          <div className="mt-3 mb-3">
            <strong>{'Disclaimer: '}</strong>
            Details of the number of grants and amounts you have received have been automatically filled into this table.
            The table only displays grants paid from 1 July 1990 to the same Australian Business Number (ABN).
            The information in the table does not reflect any amounts that you may have been asked to repay, unpaid grants or if your business is subject to organisational restructuring as per the EMDG Act and Rules.
            Please check your EMDG grant history to ensure it is accurate prior to submitting your grant application.
            Should you have any questions about your grants history please contact us at
            {' '}
            <a href="mailto:EMDG.Help@austrade.gov.au">EMDG.Help@austrade.gov.au</a>
            {' '}
            or on 13 28 78.
          </div>

          <div className="row mb-3">
            <div className="col-md-1 pr-0 mb-1">
              <strong>{historyData.isConsultant ? 'Agent' : 'Applicant'}</strong>
            </div>
            <div className="col-md-6 p-0">
              {historyData.isConsultant ? historyData.consultancyName : historyData.organisationName}
            </div>
          </div>
          <TableBody<DashboardDetailModel>
            id="historyClaims"
            columns={columns}
            value={
              historyData.dashboardDetailModels.filter(
                (r) => `
                ${r.grantYear}
                ${historyData.isConsultant ? r.organisationName : ''}
                ${r.claimRandomIdentifier}
                 ${r.primaryContactName} 
                 ${r.agentContactName} 
                 ${r.applicationStatus} 
                 ${r.totalAmountPaid}`
                  .toLowerCase().indexOf(searchTxt.toLowerCase()) >= 0,
              )
              }
            alwaysShowAllRows
            noRowsMessage="No search results returned"
          />
          <Backdrop on={loading} />
        </>
      )
    }
}
